module.exports = __webpack_public_path__ + "img/pic_circle.13901dda.png";